import Truncate from "../../../bootstrap/Truncate/index.jsx";
import {
  CardWrapper,
  RelatedCalendar,
  RelatedCalenderImg,
  RelatedDate,
  SingleImg,
  TextWrapper,
  Title,
} from "./Card.styles.js";
import { addServiceImageFallback } from "../../../utils/fallbackImgHandlers.js";

const Card = ({
  item,
  icon,
  headerLength,
  url,
  descriptaionLength,
  ...styles
}) => {
  return (
    <CardWrapper {...styles}>
      <SingleImg
        src={item?.image}
        onError={addServiceImageFallback}
        alt="workAreasPhoto"
        {...styles}
      />
      <TextWrapper>
        {icon && (
          <RelatedCalendar>
            <RelatedCalenderImg src={icon} alt="calendarIcon" />
            <RelatedDate>{item?.created_at}</RelatedDate>
          </RelatedCalendar>
        )}
        <Title header={item?.title} headerLength={headerLength} />
        <Truncate str={item?.description} number={descriptaionLength} />
      </TextWrapper>
    </CardWrapper>
  );
};

export default Card;
